import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { SwModalframeComponent } from '../../sw-modal-frame/sw-modal-frame.component';
import Cropper from 'cropperjs'

@Component({
  selector: 'app-sw-upload-cut-box',
  templateUrl: './sw-upload-cut-box.component.html',
  styleUrls: ['./sw-upload-cut-box.component.css']
})
export class SwUploadCutBoxComponent implements OnInit {

  /**
   * 动态创建裁剪组件的模态框的传入的参数
   */
  @Input() param:any;

  /**
   * 动态创建裁剪组件的模态框的回调
   */
  @Output() callback = new EventEmitter(); 
  
  /**
   * 父组件传递过来的宽高配置,如果不传,此为默认 100 x 100
   */
  myStyle:any = {
    width:'100px',
    height:'100px'
  }

  /**
   * 常量配置模态框
   * @ignore
   */
  @ViewChild("cutModal") cutModal: SwModalframeComponent;

  /**
   * @ignore
   * 裁剪的图片img元素
   */
  image:any 

  /**
   * @ignore
   * 新建的裁剪对象
   */
  cropper:any  

  /**
   * @ignore
   * 待上传文件
   */
  waitToUploadImg:any 

  constructor(
    
    private el:ElementRef ,
  ) { }

  ngOnInit() {
    this.myStyle = this.param.myStyle
    this.waitToUploadImg = this.param.waitToUploadImg
  }

  ngAfterViewInit(): void {
    let file = this.param.file
    //裁剪功能
    let fr = new FileReader();
    fr.readAsDataURL(file.source.source);
    fr.onload =  ()=> {   //异步读取文件结束之后
      this.image = this.el.nativeElement.querySelector('#cropperImg')  //裁剪功能需要的
      this.iniCropper();
      this.image['setAttribute']('src', fr.result);
      if(this.cropper){
        //如果加入到队列中的图片不是裁剪之后的,就改变裁剪区域的图片
        if(file.source.source.cutted !== true){
          this.image.cropper['replace'](fr.result)
        }
      }
    };
  }
  /**
   * @ignore
   * iniCropper() 裁剪初始化
   */
  iniCropper() {
    this.cropper = new Cropper(this.image, {
    //  aspectRatio: 16 / 16,    //裁剪区域的比例,不设置的话,默认 NaN , 最大宽高就是父容器的宽高
     crop(event) {
     },
     viewMode:1
   });
  }

  /**
   * @ignore
   * cutImage() 确认裁剪并上传
   */
  cutImage() {
    let w = parseInt(this.myStyle.width.substring(0,this.myStyle.width.length-2))
    let h = parseInt(this.myStyle.height.substring(0,this.myStyle.height.length-2))
    const canVas = this.image.cropper['getCroppedCanvas']('', {'width': w, 'height': h});
    var dataURL = canVas.toDataURL();
    var blob = this.processData(dataURL,this.waitToUploadImg.type);
    this.cutModal.toggle()   //关闭裁剪模态框
    this.callback.emit({cutted:true,blob:blob})  //传递参数
  }

  /* 使用二进制方式处理dataUrl , 并返回 blob*/
  processData(dataUrl,type) {
    var arr = dataUrl.split(','), mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { 'type': type });
  }

  //取消裁剪
  closeCut(){
    //直接将未裁剪的图片上传
    this.waitToUploadImg.source.source.cutted = true
    this.cutModal.toggle()   //关闭裁剪模态框
    this.callback.emit({cutted:false,blob:null})  //传递参数
  }
}
